import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function InformationFill({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M2.1001 12C2.1001 6.52233 6.53263 2.09998 12.0001 2.09998C17.4682 2.09998 21.9001 6.53192 21.9001 12C21.9001 17.468 17.4682 21.9 12.0001 21.9C6.52245 21.9 2.1001 17.4674 2.1001 12ZM11.9902 7.1L11.9852 7.10001L11.9802 7.1C11.9555 7.1 11.931 7.101 11.9068 7.10295C11.309 7.14545 10.8402 7.64101 10.8402 8.25C10.8402 8.85365 11.3301 9.4 11.9902 9.4C12.3314 9.4 12.6138 9.2467 12.8004 9.06015C12.9869 8.8736 13.1402 8.59117 13.1402 8.25C13.1402 7.60661 12.6339 7.15402 12.0809 7.10451C12.0511 7.10153 12.0208 7.1 11.9902 7.1ZM12.9002 12C12.9002 11.5029 12.4973 11.1 12.0002 11.1C11.5032 11.1 11.1002 11.5029 11.1002 12V17C11.1002 17.4971 11.5032 17.9 12.0002 17.9C12.4973 17.9 12.9002 17.4971 12.9002 17V12Z" fill="currentColor" /></Svg>;
}
export default InformationFill;